import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
    palette: {
        primary: {
            main: '#191919',
        },
        secondary: {
            main: '#fff'
        },
    },
});